"use client";

import { FC, useContext } from "react";
import { Control, FieldValues, UseFormRegister, UseFormSetValue } from "react-hook-form";

import { Filter, FilterType, FieldTypes } from "@types";
import { AppContext, IAppContext } from "context";

import { InputField } from "../fields/InputField";
import { DropdownFilter } from "./DropdownFilter";
import { LocationFilter } from "./LocationFilter";

interface Props {
  filters: Filter[];
  register: UseFormRegister<FieldValues>;
  control: Control;
  setValue: UseFormSetValue<any>;
}

export const Filters: FC<Props> = ({ filters, register, control, setValue }) => {
  const { searchedByLocation } = useContext(AppContext) as IAppContext;

  return (
    <>
      {filters.map((filter: Filter) => (
        <div key={filter.key}>
          {filter.type === FilterType.Dropdown && (
            <DropdownFilter
              name={filter.key}
              label={filter.label}
              id={filter.key}
              options={filter.options}
              control={control}
              settings={filter.settings}
              disabled={filter.key === "orderBy" && searchedByLocation}
            />
          )}
          {filter.type === FilterType.Search && (
            <InputField
              label={filter.label}
              id={filter.key}
              name={filter.key}
              type={FieldTypes.search}
              register={register}
              placeholder={filter.placeholder}
              disabled={filter.key === "term" && searchedByLocation}
            />
          )}
          {filter.type === FilterType.Location && (
            <LocationFilter
              label={filter.label}
              id={filter.key}
              control={control}
              setValue={setValue}
              settings={filter.settings}
              defaultValueLabel={filter.defaultValueLabel}
            />
          )}
        </div>
      ))}
    </>
  );
};
